import { useState } from 'react';
import api from '../api/api';

const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const request = async ({ method, url, data = null, params = {}, withAuth = false }) => {
    setLoading(true);
    setError(null);

    try {
      const headers = {};
      if (withAuth) {
        const token = localStorage.getItem('access_token');
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }
      }
      const response = await api({
        method,
        url,
        data,
        params,
        headers
      });
      return response.data;
    } catch (err) {
      setError(err);
      console.error("API Error:", err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { request, loading, error };
};

export default useApi;
